import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import IconButton from '@material-ui/core/IconButton';
import Info from '@material-ui/icons/Info';

import { formatPrice } from 'helpers/utils';
import PlaceOrderDialog from '../PlaceOrderDialog';

class GridCustomTile extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
  };

  static propTypes = {
    info: PropTypes.shape({
      availableQuantity: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
    }),
    invoice: PropTypes.shape({
      delivery_date: PropTypes.string,
    }).isRequired,

    addItem: PropTypes.func.isRequired,
  };

  static defaultProps = {
    info: [],
  };

  state = {
    open: false,
    value: {},
  };

  getContent = (item) => {
    const uoms = sortBy(item.packrows, 'count');

    const content = (
      <div className="content">
        <div className="uoms">
          {
            uoms.map((uom, index) => (
              <div key={index} className="uom">
                <span>{`${uom.count} ${uom.uom} ${uom.pack}`}</span>
                <span>
                  {
                    `$${formatPrice(((uom.price * (100 - (uom.discount || 0))) / 100))}`
                  }
                </span>
              </div>
            ))
          }
        </div>
      </div>
    );
    return content;
  }

  getTitle = (item) => {
    const title = (
      <div className="title">
        <div className="product">
          <div>{item.productData.name}</div>
          <div>{item.productData.subname}</div>
        </div>
      </div>);

    return title;
  }

  handleClose = () => this.setState({ open: false });

  handleOpen = value => this.setState({ open: true, value });

  render() {
    const { addItem, info, invoice } = this.props;
    const { open, value } = this.state;
    return (
      <GridListTile
        className="grid-title"
        style={{
          border: '1px solid grey',
          height: 220,
        }}
      >
        <img
          alt=""
          className="item-image"
          onClick={() => this.handleOpen(info)}
          src={info.image}
        />
        <PlaceOrderDialog
          addItem={addItem}
          info={value}
          invoice={invoice}
          onRequestClose={this.handleClose}
          open={open}
        />
        <GridListTileBar
          actionIcon={
            <IconButton onClick={() => this.handleOpen(info)}>
              <Info color="action" />
            </IconButton>
          }
          title={this.getTitle(info)}
        />
      </GridListTile>
    );
  }
}

export default GridCustomTile;
